import { defineReactiveModel, Persistable, belongsTo } from "vue-app-utils";
import Model from "@/models/model";

const Team = {
  extends: Model,
  mixins: [
    Persistable,
    belongsTo("match")
  ],
  data () {
    return {
      playerIds: [],
      goals: 0
    };
  },
  computed: {
    players () {
      if (!this.playerIds || !this.match || !this.match.tournament) return [];
      return this.playerIds
        .map(id => this.match.tournament.players.find(p => p.id === id))
        .filter(Boolean);
    }
  }
};

export default defineReactiveModel(Team);